import '../styles/main.css';

import jQuery from "jquery";
import slick from "slick-carousel";

// slick-carousel 2.x exports a factory when bundled; it must be handed the
// jQuery instance explicitly (1.8.x used to self-register via require('jquery')).
slick(window, jQuery);
window.jQuery = window.$ = jQuery;

import './theme/index';
import './global/index';
import './sections/index';
import './components/index';
